import { AppState } from '../../types';
import { StateListDocuments, StateForms, TemplateDocument } from './types';
import { createSelector } from "reselect";

export const selectDocumentsList = (state: AppState):StateListDocuments => state.documents.list;

export const selectDocumentForms = (state: AppState): StateForms => state.documents.forms;

export const selectDocumentTemplate = (state: AppState): TemplateDocument => state.documents.template;

export const selectDocumentForm = (id: number) =>
  createSelector(
    selectDocumentForms,
    (state) => {
      return state.forms? state.forms.find(item => item.id === id) : null;
    }
  );
